import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

// breakpoints 1020px

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '25px',
    padding: '5px 25px',

    [theme.breakpoints.up('sm')]: {
      padding: '5px 100px 25px',
    },
  },

  heroSectionImgWrapper: {
    flexShrink: 0,
    width: '270px',
    height: '177px',
    position: 'relative',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  btnWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
      marginBottom: '25px',
    },
  },

  planBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '20px',
    [theme.breakpoints.down('lg')]: {
      columnGap: '10px',
    },

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  mobilePlanBtnContainer: {
    [theme.breakpoints.up('sm')]: {
      //display: 'none',
    },
  },

  mobileBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '55px',
    height: '90px',
    overflow: 'hidden',
  },

  planAmountWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  planAmount: {
    display: 'flex',
    justifyContent: 'center',
    padding: '8px 5px',
  },
});
